import { render, staticRenderFns } from "./role-menu-info.vue?vue&type=template&id=6ac2713c&scoped=true&"
import script from "./role-menu-info.vue?vue&type=script&lang=js&"
export * from "./role-menu-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2713c",
  null
  
)

export default component.exports